import styled from '@emotion/styled'
import { colors } from 'utils/colors'
import { BREAKPOINTS, pxToRem } from 'utils/styled'
import { Stack } from 'components/Stack'

export const SInfoBlockWrapper = styled.div`
  display: block;
  margin: 0 var(--p-content);

  @media ${BREAKPOINTS.MD.max} {
    text-align: center;
  }
`

export const SCardsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  position: relative;
  padding: 43px 0;
  margin-top: 2rem;
  margin-bottom: 7.5rem;

  @media ${BREAKPOINTS.MD.min} {
    &:before {
      content: '';
      border: 2px solid var(--c-blue100);
      position: absolute;
      z-index: -1;
      width: calc(100% + 100px);
      top: 0;
      left: ${pxToRem(-50)}rem;
      bottom: 0;
    }
  }

  @media ${BREAKPOINTS.MD.max} {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;

    &:before {
      top: -5rem;
      bottom: 40%;
    }
  }
`

export const SCard = styled.div`
  /* width: 25%; */
  display: flex;
  flex-direction: column;

  & svg {
    color: ${colors.blue[500]};
    margin-bottom: 1rem;
    width: 2.5rem;
    height: 2.5rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    width: 50%;
    margin-bottom: ${pxToRem(20)}rem;
    align-items: center;
    margin: auto;
  }
`

export const SecurityBlock = styled(Stack)`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;

  @media ${BREAKPOINTS.MD.min} {
    grid-template-columns: repeat(2, 1fr);
    gap: 10rem;
  }
`
